export default (axios) => axios.create({
  baseURL: process.env.VUE_APP_URL_API
})
